import React from 'react';
import styled from 'styled-components';
import { Icon } from 'dlweb-components';

const SidebarButton = ({ iconType, style }) => {
  return(
    <>
      <SidebarIcon
        fixedWidth="50px"
        type={iconType}
        style={style}
      />      
    </>
  )
}

const SidebarIcon = styled(Icon)`
  /* margin-right: 20px; */
  margin-left: -17px;
  text-align: center;
`

export default SidebarButton;